import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useListenerCheck = () => {
  const { asPath } = useRouter();

  const [checkID, setCheckID] = useState<string | null>(null);

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      setCheckID(e.detail.checkID);
    };

    const handlePopState = () => {
      const match = window.location.pathname.match(/^\/check-result\/([^/]+)$/);

      if (match) {
        setCheckID(match[1]);
      } else {
        setCheckID(null);
      }
    };

    window.addEventListener('check-result:show', handler as EventListener);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('check-result:show', handler as EventListener);
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (!asPath.includes('/check-result/')) {
      setCheckID(null);
    }
  }, [asPath]);

  return checkID;
};
